import CryptoJS from 'crypto-js';

const AES_KEY = import.meta.env.VITE_AES_SECRET_KEY;
const key = CryptoJS.enc.Utf8.parse(AES_KEY);

export function generateAnswerSessionToken(params: {
  studentId: number | undefined;
  questionId: number | undefined;
}): string {
  const timestamp = Date.now();
  const payload = `${timestamp}|${params.studentId ?? ''}|${params.questionId ?? ''}|${navigator.userAgent}`;
  const encrypted = CryptoJS.AES.encrypt(payload, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}
